import { v4 as uuidv4 } from 'uuid';
import type { CimpressDocumentV2 } from '@mcp-artwork/cimdoc';
import { getImageDimensions } from '../tools';
import { Length } from '../tools/length';
import { getTransientDocumentUrl } from './urlHelpers';

export async function createCimdocWithImage(
    fileUrl: string,
    previewImageUrl: string,
    signal: AbortSignal,
): Promise<string> {
    const imageDimensions = await getImageDimensions(previewImageUrl, signal);
    const width = imageDimensions?.width
        ? `${Math.round(Length.pixels(imageDimensions.width).toMillimeters().value)}mm`
        : '250mm';
    const height = imageDimensions?.height
        ? `${Math.round(Length.pixels(imageDimensions.height).toMillimeters().value)}mm`
        : '250mm';

    const cimdoc: CimpressDocumentV2 = {
        documentId: uuidv4(),
        version: '2',
        deleted: false,
        revision: 0,
        document: {
            panels: [
                {
                    id: uuidv4(),
                    decorationTechnology: 'offsetOrDigital',
                    name: 'page-1',
                    width,
                    height,
                    images: [
                        {
                            id: uuidv4(),
                            printUrl: fileUrl,
                            previewUrl: previewImageUrl,
                            zIndex: 4,
                            position: {
                                x: '0mm',
                                y: '0mm',
                                width: `${width}`,
                                height: `${height}`,
                            },
                            horizontalAlignment: 'left',
                            verticalAlignment: 'top',
                            pageNumber: 0,
                        },
                    ],
                },
            ],
        },
        fontRepositoryUrl:
            'https://fonts.documents.cimpress.io/v1/repositories/0a3b1fba-8fa6-43e1-8c3e-a018a5eb8150/published',
    };
    return getTransientDocumentUrl(cimdoc);
}
